module.exports = __webpack_public_path__ + "static/media/ArrowRightGrey.9271604b.svg";